import { ApprovalStatus } from '@css-xp/apd-common';

export const DATE_TIME_FORMAT = 'MMM dd, yyyy, hh:mm aa xxx';

export const OPEN_TASK_STATUS = [
  ApprovalStatus.IN_REVIEW,
  ApprovalStatus.REASONS_REQUESTED,
  ApprovalStatus.REASONS_PROVIDED,
  ApprovalStatus.WAITING_FOR_REVIEW,
];

export const CLOSED_TASK_STATUS = [ApprovalStatus.APPROVED, ApprovalStatus.DECLINED, ApprovalStatus.REQUEST_CANCELED];

export const OPEN_TASKS_TAB = 'Open requests';
export const COMPLETED_TASKS_TAB = 'History';
